// Test Plan Types
export interface TestPlan {
    id: number
    name: string
    test_project_id: number
    notes?: string
    active: boolean
    is_open: boolean
    is_public: boolean
    api_key?: string
    created_at: string
    updated_at: string
    project_name?: string
    project_prefix?: string
    build_count?: number
    testcase_count?: number
    builds?: Build[]
    testcases?: TestPlanTestCase[]
    project_id: number
}

export interface Build {
    id: number
    testplan_id: number
    name: string
    notes?: string
    active: boolean
    is_open: boolean
    release_date?: string
    closed_on_date?: string
    created_at: string
    testplan_name?: string
    execution_count?: number
    execution_stats?: {
        total: number
        passed: number
        failed: number
        blocked: number
        not_run: number
    }
}

export interface Platform {
    id: number
    test_project_id: number
    name: string
    notes?: string
    enable_on_design: boolean
    enable_on_execution: boolean
    is_open: boolean
    created_at: string
    project_name?: string
    project_prefix?: string
}

export interface TestPlanTestCase {
    id: number
    testplan_id: number
    tcversion_id: number
    platform_id?: number
    urgency: number
    node_order: number
    testcase_name: string
    platform_name?: string
    importance?: number
    execution_type?: number
}

// Request/Response Types
export interface CreateTestPlanRequest {
    name: string
    test_project_id: number
    notes?: string
    is_public?: boolean
    generate_api_key?: boolean
}

export interface UpdateTestPlanRequest {
    name?: string
    notes?: string
    active?: boolean
    is_open?: boolean
    is_public?: boolean
}

export interface CreateBuildRequest {
    testplan_id: number
    name: string
    notes?: string
    release_date?: string
    is_open?: boolean
}

export interface UpdateBuildRequest {
    name?: string
    notes?: string
    active?: boolean
    is_open?: boolean
    release_date?: string
    closed_on_date?: string
}

export interface CreatePlatformRequest {
    test_project_id: number
    name: string
    notes?: string
    enable_on_design?: boolean
    enable_on_execution?: boolean
}

export interface UpdatePlatformRequest {
    name?: string
    notes?: string
    enable_on_design?: boolean
    enable_on_execution?: boolean
    is_open?: boolean
}

export interface AssignTestCaseRequest {
    tcversion_id: number
    platform_id?: number
    urgency?: number
    node_order?: number
}

export interface TestPlansResponse {
    testplans: TestPlan[]
    limit: number
    offset: number
    count: number
}

export interface BuildsResponse {
    builds: Build[]
    limit: number
    offset: number
    count: number
}

export interface PlatformsResponse {
    platforms: Platform[]
    limit: number
    offset: number
    count: number
}

export interface AssignedTestCasesResponse {
    assignments: TestPlanTestCase[]
    limit: number
    offset: number
    count: number
}

// Urgency levels
export enum TestUrgency {
    Low = 1,
    Medium = 2,
    High = 3,
}